import { selectCategoryMetadata } from '@/domains/productDiscovery/Listings/pages/Category/selectors/category';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

export const selectCategoryIds = (
  state: SpartacuxProductDiscoveryDomainState,
): string =>
  selectCategoryMetadata(state)
    ?.breadcrumb?.reduceRight(
      (arr, last) => (last.id !== 0 ? arr.concat(last.id) : arr),
      [] as number[],
    )
    .join() ?? '';
